import React from "react";
import {Icon} from '../../common/gutenberg';
import "./index.scss";
import {BrandDriverConfigs, BrandDriverMessages} from "./brand-driver-configs.js";
import {injectIntl} from "react-intl";
import PropTypes from 'prop-types';

function BrandDriver({intl}) {
  return (
    <div className = "BrandDriver__container">
      <ul className="BrandDriver__items">
        {BrandDriverConfigs.brandDrivers.map((brandDriver) => (
          <li className="BrandDriver__value" key={brandDriver.name}>
            <h2 className="BrandDriver__title">
              {intl.formatMessage(
                BrandDriverMessages[`${brandDriver.name}_title`]
              )}{" "}
            </h2>
            <div>
              <Icon
                id={`BrandDriver_${brandDriver.name}`}
                title={`Brand Driver ${brandDriver.svgComponent}`}
                desc={`Brand Driver ${brandDriver.svgComponent}`}
                name={brandDriver.name}
                styles={{fill: "#677383", width: "111px", height: "111px"}}
              />
            </div>
            <div className="BrandDriver__msg">
              {intl.formatMessage(
                BrandDriverMessages[`${brandDriver.name}_msg`]
              )}{" "}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

BrandDriver.propTypes = {
  intl: PropTypes.object.isRequired
};

export default injectIntl(BrandDriver);
